// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */
/* eslint-disable camelcase */
// webgen:keep
import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  type AutocompleteMatchedSubstring,
  type AutocompleteMatchedSubstringWireFormat,
  NewAutocompleteMatchedSubstring,
} from '../AutocompleteMatchedSubstring/AutocompleteMatchedSubstring';

export class AutocompleteStructuredFormatting {
  readonly main_text?: string;
  readonly main_text_matched_substrings?: AutocompleteMatchedSubstring[];
  readonly secondary_text?: string;

  constructor(data: { [key: string]: any } = {}) {
    this.main_text = data.main_text;
    this.main_text_matched_substrings = (data.main_text_matched_substrings ?? []).map(
      (main_text_matched_substrings: any) =>
        NewAutocompleteMatchedSubstring(main_text_matched_substrings),
    );
    this.secondary_text = data.secondary_text;
  }

  static zero(): AutocompleteStructuredFormatting {
    const zeroValues: ExcludeMethodsDeep<AutocompleteStructuredFormatting> = {};
    return new AutocompleteStructuredFormatting(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type AutocompleteStructuredFormattingWireFormat = {
  main_text?: string;
  main_text_matched_substrings?: AutocompleteMatchedSubstringWireFormat[];
  secondary_text?: string;
};

type NewAutocompleteStructuredFormattingProps = PartialDeep<
  AutocompleteStructuredFormatting,
  { recurseIntoArrays: true }
>;
export const NewAutocompleteStructuredFormatting: (
  props: NewAutocompleteStructuredFormattingProps,
) => AutocompleteStructuredFormatting = (props) => new AutocompleteStructuredFormatting(props);

type NewAutocompleteStructuredFormattingFromWireFormatProps = PartialDeep<
  AutocompleteStructuredFormattingWireFormat,
  { recurseIntoArrays: true }
>;
export const NewAutocompleteStructuredFormattingFromWireFormat: (
  props: NewAutocompleteStructuredFormattingFromWireFormatProps,
) => AutocompleteStructuredFormatting = (props) => new AutocompleteStructuredFormatting(props);
